import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-upload"} maskId="square-filled-radius-0-stroke-1-IconFolderUpload"><path d="M2 3H10.2676L12.2676 6H22V20H12.5V14.2071L14.5 16.2071L15.2071 15.5L12 12.2929L8.79289 15.5L9.5 16.2071L11.5 14.2071V20H2V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderUpload;
